import moment from 'moment';

export const formatLastSyncTimeLocalized = (lastSuccessAt, localizeMessage) => {
  if (!lastSuccessAt) return localizeMessage('catalog.sync.time.never');

  const minutesSince = Math.max(0, moment().diff(moment(lastSuccessAt), 'minutes'));
  if (minutesSince < 1) return localizeMessage('catalog.sync.time.justNow');
  if (minutesSince < 60) {
    return localizeMessage('catalog.sync.time.minutesAgo', { minutes: minutesSince });
  }

  const hoursSince = moment().diff(moment(lastSuccessAt), 'hours');
  if (hoursSince < 24) {
    return localizeMessage('catalog.sync.time.hoursAgo', { hours: hoursSince });
  }

  const daysSince = moment().diff(moment(lastSuccessAt), 'days');
  return localizeMessage('catalog.sync.time.daysAgo', { days: daysSince });
};
